import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const BlogAll = () => {
  const [careerId, setCareerId] = useState();
  const [careers, setCareers] = useState([]);
  const [blogDatas, setBlogDatas] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const fetchAllCareers = () => {
    axios
      .get(`${API_BASE_URL}/careerCategories`)
      .then((response) => {
        setCareers(response.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching careers:", error);
      });
  };

  useEffect(() => {
    fetchAllCareers();
  }, []);

  const getAllBlog = (careerId) => {
    axios
      .get(`${API_BASE_URL}/blogs?careerId=${careerId}`)
      .then((response) => {
        // console.log(response.data?.data);
        setBlogDatas(response.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getAllBlog(careerId);
  }, [careerId]);

  const handleAddNewBlog = () => {
    navigate("/add-blog");
  };

  const handleViewAllBlog = () => {
    navigate("/all-blog");
  };

  const handleEdit = (id) => {
    navigate(`/edit-blog/${id}`);
  };
  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure you want to delete?");
    if (confirm) {
      axios
        .delete(`${API_BASE_URL}/admin/blogs/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          console.log(response);
          alert("Blog deleted successfully.");
          getAllBlog(careerId);
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting blog");
        });
    }
  };

  return (
    <>
      <div id="add-subject-inner-wrapper">
        <div className="superheader">
          <div className="subjectHeaderdiv">
            <h5>Blog</h5>
            <div className="subjectdiv2">
              <button className="handleNewSubject" onClick={handleAddNewBlog}>
                + Add New Blog
              </button>
              <button className="allSubjects" onClick={handleViewAllBlog}>
                All Blog
              </button>
            </div>
          </div>

          <div className="form-sub-container mt-4" id="form">
            <h4 className="subject-detail">Blog Details</h4>
            <div className="blogAddInputGroup">
              <label className="blogAddLabel">Select Career</label>
              <select
                className="blogAddSelect"
                value={careerId}
                onChange={(e) => setCareerId(e.target.value)}
                required
              >
                <option value="">-Select Career-</option>
                {careers.map((career) => (
                  <option value={career._id} key={career._id}>
                    {career?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="classes-table-container">
              <h5>All Blog</h5>
              <table className="classes-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Title</th>
                    <th>Language</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Sample data rows */}

                  {blogDatas.length > 0 ? (
                    blogDatas &&
                    blogDatas.map((item, idx) => (
                      <tr key={idx}>
                        <td>{idx + 1}</td>
                        <td>{item.title}</td>
                        <td>{item.language}</td>
                        <td className="table-action-icons d-flex">
                          <i
                            className="fa-solid fa-file-pen"
                            onClick={() => handleEdit(item._id)}
                          ></i>
                          &nbsp;&nbsp;
                          <i
                            className="fa-solid fa-trash-can"
                            onClick={() => handleDelete(item._id)}
                          ></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="fs-2">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogAll;
